// ⚠ BAD CODE STYLE ⚠
// Please do not use $scope ❗
// Check /docs dir for more info.
import * as angular from 'angular';
import { SpAlert } from '../../../../../components/sp-alert/sp-alert.model';

/** @ngInject */
export function Controller($scope, $state, DropboxProvisioningService) {
    const self = this;
    this.$onInit = () => {
    const groupMapping = this.resolve.groupMapping;
    $scope.groupMapping=groupMapping;
    $scope.cancel=cancel;
    $scope.autoSetting=angular.copy(groupMapping.isFullSyncEnabled);
    $scope.saveSettings = function() {
        console.log('saved');
        DropboxProvisioningService.mappingSettings.update({
            companyId: $state.params.companyId,
            appId: $state.params.appId
        },$scope.groupMapping).$promise.then(function(data) {
            self.close('ok');
        }, function(error) {
            $scope.spAlert = new SpAlert('danger', error.data.message);
        })
    }
    function cancel() {
        $scope.groupMapping.isFullSyncEnabled=$scope.autoSetting;
        self.dismiss('cancel');
    }
    };
}



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/dropbox-provisioning/dropbox-provisioning-settings/dropbox-provisioning-settings.controller.js